import InputError from './InputError';

export default {
    components: {InputError},
    props:      {
        v:           {
            required: false,
        },
        name:        {
            type:     String,
            required: true,
        },
        value:       {
            required: true,
            default:  () => null,
        },
        type:        {
            type:     String,
            required: false,
            default:  () => 'text',
        },
        disabled:    {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        autofocus:   {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        tabindex:    {
            type:     Number,
            required: false,
            default:  () => null,
        },
        label:       {
            type:     String,
            required: false,
            default:  () => null,
        },
        placeholder: {
            type:     String,
            required: false,
            default:  () => null,
        },
        lengthType:  {
            type:     String,
            required: false,
            default:  () => null
        },
        suffix:      {
            type:     String,
            required: false,
            default:  () => null
        }
    },
    data() {
        return {
            error:   false,
            focused: false,
            inputId: null
        }
    },
    beforeMount() {
        this.inputId = 'inputId_' + Math.floor(Math.random() * 1000);
    },
    methods:    {
        onUpdate(e) {
            const value = this.$refs.input.value;
            this.$emit('input', value);
            this.$emit('change', e);
        },
        onBlur(e) {
            this.focused = false;
            this.$emit('blur', e);
        },
        onFocus(e) {
            this.focused = true;
            this.$emit('focus', e);
        },
        onChange(e) {
            const value = e.target.value;
            this.$emit('input', value);
            this.$emit('change', e);
        }
    }
}
